module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_location_sola_3column@2x-41769fabed5dac493110cb67f42dbc13.webp";